"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestionHighlight = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const web_css_1 = __importStar(require("@opsbase/web-css"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const react_1 = __importStar(require("react"));
const makeMyClasses = props => {
    var _a, _b;
    const isSelected = props.highlightSelected && !!((_a = props.color) === null || _a === void 0 ? void 0 : _a.main);
    const selectedColor = (_b = props.color) === null || _b === void 0 ? void 0 : _b.main;
    return {
        root: {
            borderColor: isSelected ? selectedColor : undefined,
            boxShadow: isSelected
                ? `0 0 16px -1px ${selectedColor}`
                : props.paper
                    ? `0 0 16px -1px ${lib_palette_1.default.BorderGrey.main}`
                    : undefined,
            width: '100%',
        },
    };
};
exports.OpPerformQuestionHighlight = react_1.default.forwardRef((props, ref) => {
    const { doSelect } = (0, usePerformQuestionActions_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses, [props], props.classes);
    const handleClick = (0, react_1.useCallback)(() => {
        doSelect();
    }, [doSelect]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Pane_1.default, Object.assign({ ref: ref }, props, { onClick: handleClick, classes: { root: (0, web_css_1.cx)(myCss.root, 'selectedQuestion') } }))), [handleClick, myCss, props, ref]);
});
exports.default = exports.OpPerformQuestionHighlight;
